import { atom } from 'jotai'

/**
 * The custom property keys currently shown as columns on the customers
 * MagicTable. Mirrored here so the CSV export hook can request the same keys
 * as `includeCustomProperties` columns.
 */
export const selectedCustomPropertyColumnsAtom = atom<string[]>([])

/**
 * The customers table's filters as list API query params. Mirrored here so the
 * CSV export applies the same filters as the table, including the forced
 * filters of a saved view.
 */
export const customersFiltersApiQueryParamsAtom = atom<Record<string, string>>(
  {}
)
